import { getRefreshToken, getTenantId } from "@/lib/storeManager";
import { throwError } from "@/lib/throwError";
import { post } from "@/services/axiosUitils";
import { AuthRes, SocialLoginRes } from "@/utils/types/auth";

type Credentials = { email: string; password: string };
type SignupCredentials = {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
};

class AuthService {
  tenantId = getTenantId();

  login = async (credentials: Credentials): Promise<AuthRes> => {
    if (!credentials) {
      throwError("Credentials are required", "AuthService");
    }
    const tenantId = getTenantId();
    const config = tenantId
      ? { headers: { "X-Tenant-Id": tenantId } }
      : undefined;
    return await post<AuthRes>("/auth/login/", credentials, config);
  };

  signup = async (credentials: SignupCredentials): Promise<AuthRes> => {
    if (!credentials) {
      throwError("Credentials are required", "AuthService");
    }
    const tenantId = getTenantId();
    const config = tenantId
      ? { headers: { "X-Tenant-Id": tenantId } }
      : undefined;
    return await post<AuthRes>("/auth/", credentials, config);
  };

  logout = async (): Promise<void> => {
    const refresh = getRefreshToken();
    if (!refresh) {
      throwError("Refresh token is required", "AuthService");
    }
    await post("/auth/logout/", { refresh });
  };

  socialLogin = async (provider: string): Promise<SocialLoginRes> => {
    return await post<SocialLoginRes>(`/auth/${provider}/login/`);
  };

  forgotPassword = async (email: string): Promise<any> => {
    return await post<any>(`/forgot-password-request/`, { email });
  };
  forgotPasswordReset = async (
    id: string,
    payload: {
      new_password: string;
      confirm_password: string;
    }
  ): Promise<any> => {
    return await post<any>(`/forgot-password-reset/${id}/`, {
      new_password: payload.new_password,
      confirm_password: payload.confirm_password,
    });
  };

  refreshToken = async (): Promise<AuthRes> => {
    const refresh = getRefreshToken()!;
    if (!refresh) {
      throwError("Refresh token is required", "AuthService");
    }
    return await post<AuthRes>(
      "/auth/token-refresh/",
      new URLSearchParams({ refresh }),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
  };

  resetPassword = async (values: {
    current_password: string;
    new_password: string;
  }): Promise<any> => {
    return await post<any>(`/auth/password/change/`, values);
  };
}

const instance = new AuthService();
export default instance;
